export default function HowItWorks() {
  const steps = [
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="6" width="32" height="30" rx="4" fill="#E8C12E" fillOpacity="0.12" stroke="#E8C12E" strokeWidth="1.5"/>
          <rect x="13" y="2" width="3" height="8" rx="1.5" fill="#E8C12E"/>
          <rect x="24" y="2" width="3" height="8" rx="1.5" fill="#E8C12E"/>
          <path d="M4 16h32" stroke="#E8C12E" strokeWidth="1.5"/>
          <rect x="9"  y="22" width="5" height="5" rx="1" fill="#E8C12E" fillOpacity="0.5"/>
          <rect x="17" y="22" width="5" height="5" rx="1" fill="#E8C12E"/>
          <rect x="25" y="22" width="5" height="5" rx="1" fill="#E8C12E" fillOpacity="0.5"/>
        </svg>
      ),
      step:        '01',
      title:       'Add the people you love',
      description: 'Names, birthdays, anniversaries, enter them once. Add a note about who they are and what they like.',
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="4" y="10" width="32" height="22" rx="4" fill="#B59518" fillOpacity="0.12" stroke="#B59518" strokeWidth="1.5"/>
          <path d="M4 17l16 9 16-9" stroke="#B59518" strokeWidth="1.5"/>
          <path d="M28 6l5 4-5 4" stroke="#B59518" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M18 6h10" stroke="#B59518" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      step:        '02',
      title:       'We handle the rest, every time',
      description: 'We automatically print and mail a real, physical card on every occasion, whether it\'s a birthday that repeats every year or a one-time "thinking of you." No stamps. No trips to the store. No effort.',
    },
    {
      icon: (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20 34s-14-8.5-14-17a9 9 0 0 1 14-7.5A9 9 0 0 1 34 17c0 8.5-14 17-14 17z" fill="#9A7B12" fillOpacity="0.12" stroke="#9A7B12" strokeWidth="1.5" strokeLinejoin="round"/>
          <path d="M20 28s-8-5-8-10a5 5 0 0 1 8-4 5 5 0 0 1 8 4c0 5-8 10-8 10z" fill="#9A7B12" fillOpacity="0.5"/>
        </svg>
      ),
      step:        '03',
      title:       'They feel remembered. Always.',
      description: 'A real card in the mail, from you, right on time. No effort on your end. Just the feeling that someone who loves them was thinking of them.',
    },
  ];

  return (
    <section id="how-it-works" className="py-24 bg-white">
      <div className="section-container">

        {/* Heading */}
        <div className="text-center mb-16">
          <p className="font-body text-xs font-semibold tracking-widest text-sage uppercase mb-3">
            How it works
          </p>
          <h2 className="section-heading text-4xl sm:text-5xl">
            Set it once.<br className="hidden sm:block" /> They feel it forever.
          </h2>
          <p className="mt-4 font-body text-gray-500 text-lg max-w-xl mx-auto leading-relaxed">
            Most people mean well. Life just gets in the way. MomentSent makes
            sure the card always arrives, even on your busiest days.
          </p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((s, i) => (
            <div
              key={s.step}
              className="relative flex flex-col items-center text-center md:items-start md:text-left group"
            >
              {/* Connector line between steps (desktop) */}
              {i < steps.length - 1 && (
                <div
                  className="hidden md:block absolute top-[52px] left-[calc(50%+48px)] w-[calc(100%-96px)]"
                  style={{ height: 1, background: 'linear-gradient(90deg, #E8E0D5 0%, #F0EBE3 100%)' }}
                />
              )}

              {/* Icon container */}
              <div className="w-24 h-24 rounded-card bg-cream flex items-center justify-center mb-6
                              shadow-warm group-hover:shadow-warm-lg transition-shadow duration-300 flex-shrink-0">
                {s.icon}
              </div>

              {/* Step number */}
              <p className="font-body text-xs font-semibold tracking-widest text-gold uppercase mb-2">
                Step {s.step}
              </p>

              {/* Title */}
              <h3 className="font-heading text-xl text-navy mb-3">
                {s.title}
              </h3>

              {/* Description */}
              <p className="font-body text-gray-500 text-sm leading-relaxed">
                {s.description}
              </p>
            </div>
          ))}
        </div>

        {/* Bottom callout */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center gap-2 bg-cream rounded-full px-6 py-3 shadow-warm">
            <span className="text-lg">💌</span>
            <p className="font-body text-sm text-navy">
              <span className="font-semibold">The sender never touches a card.</span>
              {' '}Everything is printed, addressed, and mailed automatically.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
